import { Component, Input } from '@angular/core';

import { renderMarkdown } from './render-markdown';

/**
 * Renders organiser-authored markdown, everywhere it is shown.
 *
 * One component so the event page, the event-day page and the generated pack cannot drift into
 * rendering the same text three different ways.
 *
 * `[innerHTML]` WITHOUT bypassSecurityTrustHtml, deliberately. Angular sanitizes anything bound
 * this way, which is the second of the two guards on text a player's browser will run - the first
 * being renderMarkdown dropping raw HTML before it gets here. The rulebook bypasses the sanitizer
 * because it needs heading ids to survive; nothing here needs that, so nothing here gives it up.
 */
@Component({
    standalone: false,
    selector: 'abs-markdown',
    template: `<div class="markdown-body" [innerHTML]="html"></div>`
})
export class MarkdownComponent {
    @Input()
    set source(value: string | undefined | null) {
        // Rendered on assignment, not in a getter: a template binding would re-parse the markdown
        // on every change detection pass.
        this.html = renderMarkdown(value);
    }

    html = '';
}
